import React, { useContext, useEffect, useState } from "react";
import { AutoSelectDropdown } from "./AutoSelectDropdown.tsx";
import { AuthContext } from "../../context/AuthContext.js";
import { UserModel } from "../../_core/_model.ts";
import { GetUsers } from "../../_core/_request.ts";
import { AnimatePresence, motion } from "framer-motion";
import { FaSpinner } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import { useAppContext } from "../../context/AppContext.tsx";

interface request {
    placeholder: string,
    initSelect: string,
    updateUser: (user: adUser | null) => void,
    avoidUser: number[],
    needLoginUser: boolean
}

export interface adUser {
    userID: number,
    userName: string,
    userEmail: string,
    firstName: string,
    lastName: string
}


export function AdUserDD({ placeholder, initSelect, updateUser, avoidUser, needLoginUser }: request) {
    // const [users, setUsers] = useState<adUser[]>(usersList);
    //const { usersList } = useContext(AuthContext);
    const [users, setUsers] = useState<UserModel[]>([]);
    const [initVal, setInitVal] = useState("");
    const { user } = useContext(AuthContext);
    const { allUsers } = useAppContext();
    const validUsers = allUsers.filter((u) => u.userID != -1);

    useEffect(() => {
        setInitVal(initSelect);
    }, [initSelect])

    useEffect(() => {
        let usrs = (needLoginUser) ? validUsers.filter((u) => avoidUser.indexOf(u.userID) == -1) :
            validUsers.filter((u) => u.userID != user.userID && avoidUser.indexOf(u.userID) == -1);
        setUsers([...usrs]);
    }, [avoidUser])

    // useEffect(() => {
    //     GetUsers(0).then((x) => {
    //         setUsers(x.data);
    //     })
    // }, [skipItems]);

    // const applySkipFilter = (allRoles: UserModel[]) => {
    //     const filtered = allRoles.filter(
    //         (x) => (typeof skipItems != 'undefined') ? !skipItems.includes(x.userID.toString()) : x
    //     );
    //     setUsers(filtered);
    // };

    const handleSelect = (v: any) => {
        let u = users.find((x) => x.userID == v);
        if (typeof u != 'undefined') {
            let tUser = {
                userEmail: u.email, userName: u.userName, firstName: u.userFirstName,
                lastName: u.userLastName, userID: u.userID
            }
            updateUser(tUser);
        }
        else
            updateUser(null);
    };

    return (
        (users.length == 0) ?
            <AnimatePresence>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className="d-flex align-items-center gap-2 border rounded bg-light"
                    style={{ padding: "4px 8px" }}
                >
                    <Spinner animation="border" size="sm" />
                    <span className="text-muted-theme">Loading Users...</span>
                </motion.div>
            </AnimatePresence> :
            <AutoSelectDropdown
                placeholder={placeholder}
                disabled={false}
                emptyString="No User"
                options={[...[{ id: "", name: "" }], ...users?.map((x) => ({
                    id: x.userID.toString(),
                    name: x.userName,
                }))]}
                initSelect={initVal}
                onSelect={handleSelect}
            />
    );
}

export default AdUserDD;
